// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1SUxL","dragIcon":"Choice_dragIcon__1mzH1","left":"Choice_left__FtV-7","input":"Choice_input__3nGE6"};